import type { FC } from 'react';
import React, { useEffect } from 'react';
import { Spinner } from '@alfa-bank/site-loader/spinner';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { useFormContext } from '../../components/form/context';

import type { TStepByStep } from './models';

export const StepByStepLayout: FC<TStepByStep> = ({ Text, styles }) => {
    const { formId } = useFormContext();

    useEffect(() => {
        sendEvent({
            event: 'site_formRequest_modalWindow',
            formId,
            title: 'Формируем заявку',
        });
    }, [formId]);

    return (
        <div className={styles.root}>
            <Text className={styles.title} fontSize={22} fontWeight={7} lineHeight={26}>
                Формируем заявку
            </Text>
            <Spinner className={styles.spinner} thickness={3} />
            <div className={styles.description}>
                <Text tag="div">Это займет совсем немного времени.</Text>
                <Text tag="div">Пожалуйста, не обновляйте и не закрывайте страницу</Text>
            </div>
        </div>
    );
};
